import { Components, Theme } from '@mui/material/styles';

import MuiAlert from 'src/theme/overrides/v5/MuiAlert';
import MuiAutocomplete from 'src/theme/overrides/v5/MuiAutocomplete';
import MuiButton from 'src/theme/overrides/v5/MuiButton';
import MuiButtonGroup from 'src/theme/overrides/v5/MuiButtonGroup';
import MuiCheckbox from 'src/theme/overrides/v5/MuiCheckbox';
import MuiChip from 'src/theme/overrides/v5/MuiChip';
import MuiCssBaseline from 'src/theme/overrides/v5/MuiCssBaseline';
import MuiDivider from 'src/theme/overrides/v5/MuiDivider';
import MuiFormControl from 'src/theme/overrides/v5/MuiFormControl';
import MuiFormControlLabel from 'src/theme/overrides/v5/MuiFormControlLabel';
import MuiFormHelperText from 'src/theme/overrides/v5/MuiFormHelperText';
import MuiIconButton from 'src/theme/overrides/v5/MuiIconButton';
import MuiInputBase from 'src/theme/overrides/v5/MuiInputBase';
import MuiList from 'src/theme/overrides/v5/MuiList';
import MuiListItemButton from 'src/theme/overrides/v5/MuiListItemButton';
import MuiMenu from 'src/theme/overrides/v5/MuiMenu';
import MuiMenuItem from 'src/theme/overrides/v5/MuiMenuItem';
import MuiRadio from 'src/theme/overrides/v5/MuiRadio';
import MuiSelect from 'src/theme/overrides/v5/MuiSelect';
import MuiSwitch from 'src/theme/overrides/v5/MuiSwitch';
import MuiTooltip from 'src/theme/overrides/v5/MuiTooltip';
import MuiTypography from 'src/theme/overrides/v5/MuiTypography';
import MuiTextField from 'src/theme/overrides/v5/TextField';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiAlert,
  MuiAutocomplete,
  MuiButton,
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButtonGroup,
  MuiCheckbox,
  MuiChip,
  MuiCssBaseline,
  MuiDivider,
  MuiFormControl,
  MuiFormControlLabel,
  MuiFormHelperText,
  MuiIconButton,
  MuiInputBase,
  MuiList,
  MuiListItemButton,
  MuiMenu,
  MuiMenuItem,
  MuiRadio,
  MuiSelect,
  MuiSwitch,
  MuiTextField,
  MuiTooltip,
  MuiTypography,
};
